<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="agentcode,agentname,ct_custname"
      placeholder="输入代理商编号、名称、客户进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'AgentClientput', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.agentname}}</p>
          <p class="list-item-muted">{{item.agentcode}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'yyyy-MM-dd'">{{item.ct_date}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ct_status!='已审核'}"
          >{{item.ct_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}条</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/agent/clientput/list",
      filters: [
        {
          type: "date",
          name: "clientput.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待同意",
              condition: "ifnull(ct_result,'待同意')='待同意'",
              mode: "MAIN"
            },
            {
              value: 2,
              label: "已同意",
              condition: "ifnull(ct_result,'待同意')='已同意'",
              mode: "MAIN"
            },
          ]
        }
      ],
    }
  },
}
</script>